/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskReportsSatisfaction2Route } from '@jira/router-routes__servicedesk-reports-routes/src/servicedeskReportsSatisfaction2Route.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import SatisfactionReports, {
	LazyServicedeskReportsSatisfaction,
} from './ui/satisfaction/index.tsx';

export const servicedeskReportsSatisfaction2RouteEntry: Route = createEntry(
	servicedeskReportsSatisfaction2Route,
	() => ({
		group: 'servicedesk',
		perfMetricKey: 'service-management.reports.satisfaction',
		// eslint-disable-next-line no-restricted-syntax
		component: SatisfactionReports,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskReportsSatisfaction],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
